function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
console.log("---global---")


class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    
    // 初始化DOM元素引用
    this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells");
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productID = this.getAttribute("productID")
   
    
    // 初始化配置选项
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.updateUnavailable = this.dataset.updateUnavailable === 'true';
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    
    // 初始化数据存储
    this.selectedVariants = {
      'input_1': [],
      'input_2': [],
      'input_3': [],
      'input_4': [],
      'input_5': [],
      'input_6': []
    };
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    
    // 设置初始选中的数量和offer
    const inputCheckedEl = this.querySelector('input[checked]');
    if (inputCheckedEl) {
      this.selectedQuantity = parseInt(inputCheckedEl.value);
      this.selectedOffer = parseInt(inputCheckedEl.dataset.input.replace("input_", ''));
    }
    
    // 初始化变体选择器
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    
    // 初始化PDP价格更新
    if (this.updatePdpPrices) {
      this.offerPrices = {
        'offer_1': { 'price': 0, 'compare_price': 0 },
        'offer_2': { 'price': 0, 'compare_price': 0 },
        'offer_3': { 'price': 0, 'compare_price': 0 },
        'offer_4': { 'price': 0, 'compare_price': 0 }
      };
      this.initOfferPrices();
    }
    
    // 初始化变体处理
    if (this.hasVariants) {
      this.initVariants();
    }
    
    // 绑定事件监听器
    this.inputs.forEach(input => {
      input.addEventListener("change", this.handleChange.bind(this));
    });
     document.addEventListener(ThemeEvents.variantUpdate, (e) => { 
      this.renderProductInfo(e)
     });
    this.variantSelects.forEach(variant => {
      variant.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  renderProductInfo(e) {
    this.currentVariantId = e.detail.resource.id;
    const sectionId = this.productID;
    const url = this.getAttribute("data-url")
    fetch(url + "?variant=" + this.currentVariantId + "&section_id=" + sectionId)
      .then(response => response.text())
      .then(htmlText => {
        // 确保当前变体没有改变
        if (e.detail.resource.id !== this.currentVariantId) {
          return;
        }
        const parsedHTML = new DOMParser().parseFromString(htmlText, 'text/html');
        // this.updateProductInfoElements(parsedHTML, sectionId);
        this.updateQuantityBreaks(parsedHTML, sectionId);
        // this.updateQuantityBreaksPicker(parsedHTML, sectionId);
        // this.updateSecondarySelect(parsedHTML, sectionId);
      });
  }
   updateQuantityBreaks(parsedHTML,sectionId) {

    // if (!this.QuantityBreaks) return;
    
    const newQuantityBreaks = parsedHTML.getElementById('quantity-breaks-' + sectionId);
    if (!newQuantityBreaks) return;
    
    // 更新动态价格
    const dynamicPriceElements = this.querySelectorAll(".dynamic-price");
    const newDynamicPriceElements = newQuantityBreaks.querySelectorAll(".dynamic-price");
    for (let i = 0; i < dynamicPriceElements.length; i++) {
      if (newDynamicPriceElements[i]) {
        dynamicPriceElements[i].innerHTML = newDynamicPriceElements[i].innerHTML;
      }
    }
    
    // 更新变体选择器
    if (this.hasVariants) {
      this.variantSelects.forEach(select => {
        select.dataset.selectedId = this.currentVariantId;
      });
      
      const variantSelects = this.querySelectorAll(".quantity-break__variant-select");
      const newVariantSelects = newQuantityBreaks.querySelectorAll('.quantity-break__variant-select');
      
      for (let i = 0; i < variantSelects.length; i++) {
        if (newVariantSelects[i]) {
          variantSelects[i].innerHTML = newVariantSelects[i].innerHTML;
        }
      }
      
      this.initVariants();
    }
    
    // 更新选择器图片
    this.querySelectorAll(".quantity-break__selector-item__image img").forEach(img => {
      img.src = this.currentVariant.featured_image.src;
    });
    
    // 更新PDP价格
    if (this.dataset.updatePdpPrices === "true") {
      this.dataset.basePrice = newQuantityBreaks.dataset.basePrice;
      
      this.labels.forEach(label => {
        const newLabel = newQuantityBreaks.querySelector("label[data-input=\"" + label.dataset.input + "\"]");
        if (newLabel) {
          label.dataset.baseComparePrice = newLabel.dataset.baseComparePrice;
        }
      });
      
      this.initOfferPrices();
    }
  }
  initOfferPrices() {
    this.pdpPrices = document.querySelectorAll(".price-" + this.dataset.section);
    const basePrice = parseInt(this.dataset.basePrice);
    
    this.labels.forEach((label, index) => {
      const offerNumber = index + 1;
      const quantity = parseInt(label.dataset.quantity);
      const discountPercentage = parseFloat(label.dataset.percentageLeft);
      const fixedDiscount = parseFloat(label.dataset.fixedDiscount);
      const baseComparePrice = parseInt(label.dataset.baseComparePrice);
      
      // 计算优惠价格
      const discountedPrice = basePrice * quantity * discountPercentage - fixedDiscount;
      const comparePrice = baseComparePrice * quantity;
      
      this.offerPrices["offer_" + offerNumber].price = discountedPrice;
      this.offerPrices['offer_' + offerNumber].compare_price = comparePrice;
    });
    
    this.updateDisplayedPdpPrices();
  }

  updateDisplayedPdpPrices() {
    const currentPrice = this.offerPrices["offer_" + this.selectedOffer].price;
    const formattedPrice = formatMoney(currentPrice, this.moneyFormat);
    const currentComparePrice = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    const formattedComparePrice = formatMoney(currentComparePrice, this.moneyFormat);
    const isOnSale = currentComparePrice > currentPrice;
    
    this.pdpPrices.forEach(priceElement => {
      priceElement.classList.toggle('price--on-sale', isOnSale);
      
      // 更新常规价格
      const regularPriceEl = priceElement.querySelector(".price__regular .price-item--regular");
      if (regularPriceEl) regularPriceEl.innerHTML = formattedPrice;
      
      // 更新销售价格
      const salePriceEl = priceElement.querySelector(".price__sale .price-item--sale");
      if (salePriceEl) salePriceEl.innerHTML = formattedPrice;
      
      if (isOnSale) {
        // 更新原价显示
        const comparePriceEl = priceElement.querySelector(".price__sale .price-item--regular");
        if (comparePriceEl) {
          comparePriceEl.innerHTML = formattedComparePrice;
        }
        
        // 更新节省百分比徽章
        const percentageSavedEl = priceElement.querySelector(".badge__percentage-saved");
        if (percentageSavedEl) {
          const percentageSaved = Math.round((currentComparePrice - currentPrice) * 100 / currentComparePrice);
          percentageSavedEl.innerHTML = percentageSaved;
        }
        
        // 更新节省金额徽章
        const moneySavedEl = priceElement.querySelector(".badge__money-saved");
        if (moneySavedEl) {
          const moneySaved = currentComparePrice - currentPrice;
          const formattedMoneySaved = formatMoney(moneySaved, this.moneyFormat, true);
          moneySavedEl.innerHTML = formattedMoneySaved;
        }
      }
    });
    
    // 更新ATC按钮价格
    const atcPriceElements = document.querySelectorAll('.main-atc-price-span-' + this.dataset.section);
    atcPriceElements.forEach(element => {
      element.innerHTML = formattedPrice;
    });
  }

  handleSelectChange(event) {
    const variantSelector = event.currentTarget;
    const selectedOptions = Array.from(variantSelector.querySelectorAll('select'), select => select.value);
    
    // 更新不可用变体状态
    if (this.updateUnavailable) {
      const availableVariants = this.getVariantData().filter(variant => 
        variantSelector.querySelector(":checked").value === variant.option1
      );
      const selectElements = [...variantSelector.querySelectorAll(".select--small")];
      updateVariantStatuses(availableVariants, selectElements, this.skipUnavailable);
    }
    
    // 查找匹配的变体
    const matchedVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => {
        return selectedOptions[index] === option;
      }).includes(false);
    });
    
    if (!matchedVariant) {
      if (this.skipNonExistent) {
        findAvailableVariant(variantSelector, selectedOptions, false, true, this.skipUnavailable);
      }
      return;
    }
    
    // 处理不可用变体
    if (this.skipUnavailable && !matchedVariant.available) {
      if (findAvailableVariant(variantSelector, selectedOptions, false, true, true)) {
        return;
      }
    }
    
    // 更新选中的变体ID
    variantSelector.dataset.selectedId = matchedVariant.id;
    const selectIndex = variantSelector.dataset.selectIndex;
    const quantityBreak = variantSelector.closest(".quantity-break");
    const inputName = quantityBreak.dataset.input;
    
    this.selectedVariants[inputName][selectIndex] = matchedVariant.id;
    this.formVariants = this.selectedVariants[inputName];
 
    // 更新媒体显示
    if (!this.preventGalleryScroll) {
      this.updateMedia(matchedVariant);
    }
    
    // 更新变体选择器图片
    const variantImage = variantSelector.querySelector(".quantity-break__selector-item__image img");
    if (variantImage) {
      variantImage.src = matchedVariant.featured_image.src;
    }
    
    if (!this.updatePrices) {
      return;
    }
    
    // 计算价格
    let totalPrice = 0;
    let totalComparePrice = 0;
    const quantity = parseFloat(quantityBreak.dataset.quantity);
    const discountPercentage = parseFloat(quantityBreak.dataset.percentageLeft);
    const fixedDiscount = parseFloat(quantityBreak.dataset.fixedDiscount);
    let useCompareMode = true;
    
    if (quantityBreak.dataset.compareMode === "price") {
      useCompareMode = false;
    }
    
    // 计算所有变体的总价
    for (let i = 0; i < quantity; i++) {
      const variantId = parseInt(this.selectedVariants[inputName][i]);
      const variant = this.getVariantData().find(v => parseInt(v.id) === variantId);
      
      if (!variant) {
        return;
      }
      
      totalPrice += variant.price;
      
      if (variant.compare_at_price && useCompareMode && variant.compare_at_price > variant.price) {
        totalComparePrice += variant.compare_at_price;
      } else {
        totalComparePrice += variant.price;
      }
    }
    
    // 应用折扣
    const discountedPrice = totalPrice * discountPercentage - fixedDiscount;
    const amountSaved = totalComparePrice - discountedPrice;
    const roundedAmountSaved = Math.round(amountSaved / 100) * 100;
    const priceEach = discountedPrice / quantity;
    const comparePriceEach = totalComparePrice / quantity;
    
    // 格式化价格
    const formattedPrice = formatMoney(discountedPrice, this.moneyFormat, true);
    const formattedComparePrice = formatMoney(totalComparePrice, this.moneyFormat, true);
    const formattedAmountSaved = formatMoney(amountSaved, this.moneyFormat, true);
    const formattedRoundedAmountSaved = formatMoney(roundedAmountSaved, this.moneyFormat, true);
    const formattedPriceEach = formatMoney(priceEach, this.moneyFormat, true);
    const formattedComparePriceEach = formatMoney(comparePriceEach, this.moneyFormat, true);
    
    // 更新价格显示
    quantityBreak.querySelectorAll('.variant-price-update').forEach(priceElement => {
      let priceText = priceElement.dataset.text;
      priceText = priceText.replace('[quantity]', quantity);
      priceText = priceText.replace("[price]", formattedPrice);
      priceText = priceText.replace("[compare_price]", formattedComparePrice);
      priceText = priceText.replace("[amount_saved]", formattedAmountSaved);
      priceText = priceText.replace('[amount_saved_rounded]', formattedRoundedAmountSaved);
      priceText = priceText.replace("[price_each]", formattedPriceEach);
      priceText = priceText.replace('[compare_price_each]', formattedComparePriceEach);
      priceElement.innerHTML = priceText;
    });
    
    // 更新比较价格显示
    const comparePriceElement = quantityBreak.querySelector('.quantity-break__compare-price');
    if (comparePriceElement) {
      if (totalComparePrice > discountedPrice) {
        comparePriceElement.classList.remove("hidden");
      } else {
        comparePriceElement.classList.add('hidden');
      }
    }
    
    // 更新PDP价格
    if (this.updatePdpPrices) {
      this.offerPrices['offer_' + this.selectedQuantity].price = discountedPrice;
      this.offerPrices["offer_" + this.selectedQuantity].compare_price = totalComparePrice;
      this.updateDisplayedPdpPrices();
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }

  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    
    this.labels.forEach(label => {
      if (label.querySelector(".quantity-break__variants")) {
        let selectedIds = [];
        label.querySelectorAll(".quantity-break__selector-item").forEach(selector => {
          selectedIds.push(selector.dataset.selectedId);
        });
        this.selectedVariants[label.dataset.input] = selectedIds;
      }
    });
    
    this.formVariants = [];

  }

  updateMedia(variant) {
    if (!variant || !variant.featured_media) {
      return;
    }
    
    const mediaGalleries = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    mediaGalleries.forEach(gallery => {
      gallery.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, true);
    });
  }

  handleChange(event) {
    const selectedQuantity = parseInt(event.target.value);
    this.selectedQuantity = selectedQuantity;
    this.selectedOffer = parseInt(event.target.dataset.input.replace("input_", ''));
    
    // 更新选中的变体
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[event.target.dataset.input];
    }
    
    // 解锁礼物
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(selectedQuantity);
    }
    
    // 初始化upsell解锁
    this.quantityBreakUpsells.forEach(upsell => {
      upsell.initUnlock();
    });
    
    // 更新PDP价格显示
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);


// 自定义购买按钮
customElements.define("checkout-button", class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleCheckout.bind(this));
  }
  handleCheckout() {
    this.quantityBreak = document.querySelector("quantity-breaks");
    const id = this.getAttribute("product-id");
    const form = Array.from(document.querySelector(`#${id}`));
    let checkoutStr = `/cart/`

    if(this.quantityBreak &&this.quantityBreak.formVariants != 0){
      this.quantityBreak.formVariants.forEach((id, index) => {
        checkoutStr += `${id}:1,`
      })
    }else{
      form.forEach((i, idx) => {
        if (i.name === "id") {
          checkoutStr += `${i.value}:1,`
        }
      })
    }

    window.location.href = checkoutStr
  }
})